import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static outlets = ["tiptap"];

  connect() {
    this.subscription = App.cable.subscriptions.create(
      { channel: "ScopeiqEditorChannel" },
      {
        connected: this.handleConnected.bind(this),
        disconnected: this.handleDisconnected.bind(this),
        received: this.handleReceived.bind(this)
      }
    );
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  handleConnected() {}

  handleDisconnected() {}

  handleReceived(data) {
    if (!this.hasTiptapOutlet) return;

    switch (data.type) {
      case 'processing_started':
        this.tiptapOutlet.editor.setOptions({ editable: false });
        this.tiptapOutlet.editorTarget.classList.add('tiptap-editor--ai-processing');
        break;
      case 'processing_completed':
        if (!this.tiptapOutlet.processingAiValue) {
          this.tiptapOutlet.editor.setOptions({ editable: true });
          this.tiptapOutlet.editorTarget.classList.remove('tiptap-editor--ai-processing');
        }
        break;
      case 'edit_document':
        this.tiptapOutlet.applyEditOperations(data.operations || []);
        break;
    }
  }
}
